import { render, staticRenderFns } from "./stock.vue?vue&type=template&id=0bcffb9f&scoped=true"
import script from "./stock.vue?vue&type=script&lang=js"
export * from "./stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcffb9f",
  null
  
)

export default component.exports